<template>
  <div>
    <BackupSetting />
  </div>
</template>

<script>
import BackupSetting from "@/components/Settings/BackupSetting";
export default {
  components: { BackupSetting },
};
</script>

<style lang="scss" scoped>
</style>